import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FieldItem } from 'src/app/models/common/field-item';
import { NavigationLink } from 'src/app/models/common/navigation-link';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { AgentService } from '../services/agent.service';

@Component({
  selector: '',
  template: '',
})
export class AgentPartyDetailsHandlerComponent extends BaseComponent<AgentService> implements OnChanges {
  @Input() model: any;
  public max_FileSize: number;
  public allowed_FileTypes: string[];
  public navigationLinkList: NavigationLink[];
  public agentRemarks: string;
  public isRemarksPresent: boolean = false;
  public isRejectRemark: boolean = false;

  constructor(agentService: AgentService) {
    super(agentService);
    if (this.service.getApplicationPropertyValue('IMAGE_EXTENSIONS') != undefined && this.service != undefined)
      this.allowed_FileTypes = this.service.getApplicationPropertyValue('IMAGE_EXTENSIONS').split(',');
    this.max_FileSize = parseInt(this.service.getApplicationPropertyValue('IMAGE_SIZE_LIMIT'));
    console.log(this.model);
  }

  ngOnInit() {
    this.navigationLinkList = [];
    let nav = new NavigationLink();
    nav.link = 'basic_Details_Body';
    nav.labelKey = 'personalDetails';
    this.navigationLinkList.push(nav);

    nav = new NavigationLink();
    nav.link = 'communicaton_Details_Body';
    nav.labelKey = 'addressDetails';
    this.navigationLinkList.push(nav);

    nav = new NavigationLink();
    nav.link = 'contact_Details_Body';
    nav.labelKey = 'contactDetails';
    this.navigationLinkList.push(nav);

    nav = new NavigationLink();
    nav.link = 'identity_Details_Body';
    nav.labelKey = 'identityDetails';
    this.navigationLinkList.push(nav);

    this.checkRemarkAgainstAgent();
    this.agentRejectRemark();
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
  }

  // onButtonOCRClick(event) {
  //   $('#docUploadFiles').trigger('click');
  // }

  // onFileChange(event) {
  //   if (event.target.files && event.target.files[0]) {
  //     var filesAmount = event.target.files.length;
  //     for (let i = 0; i < filesAmount; i++) {
  //       let fileName = event.target.files[i].name;
  //       let ext = fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length);
  //       if (this.allowed_FileTypes != null && !this.allowed_FileTypes.includes(ext)) {
  //         alert(this.service.getMultilingualMessage('fileTypeAllowed', [this.allowed_FileTypes.toString()]));

  //         return false;
  //       }

  //       if (this.max_FileSize != null && Math.round(event.target.files[i].size / 1024) > this.max_FileSize) {
  //         alert(this.service.getMultilingualMessage('maxFileSize', [this.max_FileSize.toString()]));
  //         return false;
  //       }
  //       var reader = new FileReader();
  //       reader.onload = (event: any) => {
  //         //console.log(event.target.result);
  //         this.populateOCRData(event, fileName);
  //       };
  //       reader.readAsDataURL(event.target.files[i]);
  //     }
  //   }
  // }

  // populateOCRData(event, fileName: string) {
  //   let respData: any;
  //   let imageContent = event.target.result;
  //   let fileDataType = this.getFileDataType(fileName);
  //   imageContent = imageContent.replace('data:image/jpeg;base64,', '');
  //   this.service.populateOCRData(imageContent).subscribe(
  //     (successResponse) => {
  //       if (successResponse['success'] == true) {
  //         respData = JSON.parse(JSON.stringify(successResponse));
  //         //console.log("Party: "+ respData.data.Party);
  //         this.service.responseIO.data.AgentParty = respData.data.Party;
  //         console.log('Populate OCR data successful.');
  //       } else {
  //         alert(successResponse['message']);
  //       }
  //     },
  //     (error) => {
  //       console.log('Populate OCR data failed.');
  //       console.log('Error:', error);
  //     }
  //   );
  // }

  // getFileDataType(fileName: string) {
  //   let ext = fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length);
  //   let fileDataType = this.service.getValueFromLookup('FILEDATATYPE', ext);
  //   return fileDataType;
  // }

  protected titleCd_change(item: FieldItem) {
    if (item.model.titleCd !== 'DR') {
      this.service.getGenderForTitle(item.model);
    }
  }

  checkRemarkAgainstAgent() {
    let applicationStatusCode = this.service.responseIO.data.Entity.applicationStatusCd;
    if (
      applicationStatusCode === null ||
      ((applicationStatusCode === 'PENDING' ||
        applicationStatusCode === 'REMOTE' ||
        applicationStatusCode === 'PENDINGPAYMENT') &&
        this.service.responseIO.data.AgentDetail.receiptStatusCd != 'COMPLETED')
    ) {
      this.isRemarksPresent = false;
    } else {
      this.isRemarksPresent = true;
      this.agentRemarks = this.service.responseIO.data.AgentDetail.remarks;
      // console.log(this.remarks);
    }
  }

  agentRejectRemark() {
    let applicationStatusCode = this.service.responseIO.data.Entity.applicationStatusCd;
    if (applicationStatusCode === 'REMOTEREJECTED') {
      this.isRejectRemark = true;
      this.agentRemarks = this.service.responseIO.data.AgentDetail.remarks;
    } else {
      this.isRejectRemark = false;
    }
  }
}
